module.exports = __webpack_public_path__ + "img/emailWeavr.364a7cea.svg";